export default {
    computed: {
        isCallAnalysisEnabled() {
            const user = this.$auth && this.$auth.user && this.$auth.user();
            if (user && user.call_analysis_enabled) {
                return true;
            }

            const profile = this.$store && this.$store.getters['ProfileModule/getProfile'];

            return !!(profile && profile.call_analysis_enabled);
        },
    },
};
